import actionResponse, { ActionResponse } from '../ActionResponse';
import { GroupStore } from '@stores';
import apiResponse from '@stores/ApiResponse';

export class SendCustomGiftCardAction {
  constructor(private readonly store: GroupStore = new GroupStore()) {}

  public async Execute(cohortUserId: number, amount: number, message?: string): Promise<ActionResponse> {
    // Validate amount
    if (!amount || amount <= 0) {
      return actionResponse.ValidationError('Amount must be greater than 0');
    }

    // The message is sent in the gift card email and stored on the prize record
    if (!message || !message.trim()) {
      return actionResponse.ValidationError('Message is required');
    }

    try {
      await apiResponse.handleApiResponse(() => this.store.SendCustomGoodyGift(cohortUserId, amount, message.trim()));
      return actionResponse.Success(`Custom gift card of $${amount} sent successfully`);
    } catch (err) {
      return actionResponse.HandleError(err);
    }
  }
}
